<script lang="ts" setup>
import ItemListSection from '../../ItemListSection.vue';
import ParagrahNote from '../../ParagrahNote.vue';
import WhereToConsultCard from '../../WhereToConsult/WhereToConsultCard.vue';

defineProps<{
  imageNumber: number;
}>();
</script>

<template>
  <WhereToConsultCard
    title="結婚資金を節約するコツ"
    :image-number="imageNumber"
  >
    <p>結婚資金を少しでも節約するために、まずは以下の4つを確認しましょう。</p>
    <h3>結婚式や新婚旅行の日程を工夫する</h3>
    <p>
      結婚式や新婚旅行は、オフシーズンを狙って日程を組むと費用を安く抑えられます。
    </p>
    <p>
      一般的に、真冬や真夏の時期の1月・2月・7月・8月や、友引の日などは料金を低く設定している式場が多いです。
    </p>
    <p>
      新婚旅行は行き先にもよりますが、大型連休や夏休み・冬休み、年末年始はどこも混み合い、飛行機や新幹線、宿泊施設の料金が高騰します。逆に、1月中旬から2月にかけて、ゴールデンウィークから夏休み前にかけて、9月から12月中旬にかけては旅行客が落ち着く時期です。
    </p>
    <h3>結婚資金を抑える箇所を2人でよく話し合う</h3>
    <p>
      例えば以下のように、結婚資金を抑えられそうな箇所を2人で話し合ってみましょう。
    </p>
    <ItemListSection>
      <li>結納式はせず、両家の顔合わせのみにする</li>
      <li>婚約指輪は買わず、結婚指輪だけにする</li>
      <li>結婚式時のペーパーアイテム、ウェルカムボード等を持ち込みにする</li>
      <li>結婚式時の衣装や料理のグレードを下げる</li>
    </ItemListSection>
    <p>
      絶対に譲れないところ、妥協してもよいところを決め、予算にメリハリをつけることが大切です。
    </p>
    <h3>助成金制度の活用を検討する</h3>
    <p>
      地域少子化対策の一環として国が行っている助成金制度に、夫婦ともに39歳以下で世帯所得500万円未満の新婚夫婦を対象に、新居の住宅費や引越費用を最大60万円まで補助する「結婚新生活支援事業」があります。
    </p>
    <p>
      ただし、結婚新生活支援事業はすべての自治体で行われているわけではありません。こども家庭庁のホームページで居住地での支援事業実施の有無を確認したうえで、補助の対象となる場合は積極的に活用しましょう。
    </p>
    <ParagrahNote>
      参照：<NuxtLink
        href="https://www.cfa.go.jp/policies/shoushika/koufukin"
        external
        target="_blank"
        >こども家庭庁_地域少子化対策重点推進交付金</NuxtLink
      >
    </ParagrahNote>
    <h3>両親の援助が期待できるか確認する</h3>
    <p>
      結婚費用に対する親・親族からの援助が「あった」と答えたカップルは78.7％にのぼり、援助総額は平均181.1万円でした。
    </p>
    <p>
      両親の経済状況やこれまでの親子関係にもよりますが、両親にお金の相談ができる状況であれば、援助が可能か相談してみると良いでしょう。
    </p>
    <ParagrahNote>
      参照：<NuxtLink
        href="https://souken.zexy.net/data/trend2023/XY_MT23_report_06shutoken.pdf"
        external
        target="_blank"
        >ゼクシィ結婚トレンド調査2023首都圏 全国（推計値）</NuxtLink
      >
    </ParagrahNote>
  </WhereToConsultCard>
</template>

<style lang="scss" module></style>
